import GenericInfo from "@casino/external/icons/GenericInfo";
import { Button } from "@workspace/frontend-ui";

const InfoButton: FC = () => (
  <Button
    type="button"
    variant="secondary"
    size="icon-xs"
    aria-label="Info"
    className="size-5 p-0"
  >
    <GenericInfo data-testid="info-tooltip" className="size-4" />
  </Button>
);

export default InfoButton;
